import { Injectable } from '@angular/core';

declare var document: any;

export interface ScriptServiceResult {
    script: string;
    loaded: boolean;
    status: ('loaded'|'preloaded'|'error');
    additional?: any;
};

interface ScriptEntry {
    loaded: boolean;
    promise?: Promise<ScriptServiceResult>;
};

@Injectable({
    providedIn: 'root'
})
export class ScriptService {

    private scripts: Record<string, ScriptEntry> = {};

    constructor() {
    }

    load(...scripts: string[]): Promise<ScriptServiceResult[]> {
        return Promise.all(scripts.map(script => this.loadScript(script)));
    }

    loadScript(name: string): Promise<ScriptServiceResult> {
        if (this.scripts[name]?.loaded) {
            return Promise.resolve({
                script: name,
                loaded: true,
                status: 'preloaded'
            });
        }

        if (this.scripts[name]?.promise) {
            return this.scripts[name].promise!;
        }

        if (typeof document === 'undefined' || !document) {
            return Promise.resolve({
                script: name,
                loaded: false,
                status: 'error',
                additional: 'Document is not defined'
            });
        }

        const promise = new Promise<ScriptServiceResult>((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = name;
            script.crossOrigin = 'anonymous'
            script.onload = () => {
                this.scripts[name].loaded = true;
                resolve({
                    script: name,
                    loaded: true,
                    status: 'loaded'
                });
            };

            script.onerror = (error: any) => {
                delete this.scripts[name];
                resolve({
                    script: name,
                    loaded: false,
                    status: 'error',
                    additional: error
                });
            };

            document.getElementsByTagName('head')[0].appendChild(script);
        });

        this.scripts[name] = {
            loaded: false,
            promise
        };

        return promise;
    }
}
